<template>
  <div class="list-wrapper">
    <ul class="yxp-uploader-list">
      <li
        v-for="(one,index,key) in list"
        :key="key"
      >
        <div class="name-box">
          <i :class="icon(one.rawFile.type, one.rawFile.name)" />
          <span class="name">{{ one.rawFile.name }}</span>
        </div>
        <div class="progress">
          <div
            v-if="one.status !== 'ready' && one.status !== 'cancel' && one.status !== 'getMd5'"
            class="trough"
            :class="{empty: one.status === 'empty'}"
          >
            <div
              v-if="one.status === 'fail'"
              class="fail"
            />
            <div
              v-else-if="one.status === 'empty'"
              class="fail empty"
            >
              {{ one.errMsg }}
            </div>
            <div
              v-else
              :style="'width:'+ (one.progress||0)+'%'"
            />
          </div>
          <span
            v-if="one.status === 'uploading' || one.status === 'succ'"
            class="num"
          >{{ showProgress(one) }}</span>
          <i
            v-else-if="one.status === 'succ1'"
            class="icon-succ"
          />
          <i
            v-else-if="one.status === 'fail'"
            class="icon-fail"
          />
          <span
            v-if="one.status === 'ready' || one.status === 'cancel' || one.status === 'getMd5'"
            class="ready-tip"
          >{{ showProgress(one) }}</span>
          <i
            v-if="one.status === 'fail' || one.status === 'cancel'"
            :key="key"
            class="icon-retry"
            title="重传"
            style="margin-left:10px;"
            @click="retry(one, index)"
          />
        </div>
        <div class="close-box">
          <i
            v-if="one.status !== 'succ'"
            class="icon-close"
            title="删除"
            @click.stop="remove(index)"
          />
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { uploadQuene } from './upload.process.js';
export default {
    name: 'YxpUploadList',
    props: {
        retryUpload: {
            type: Function,
            required: false,
            default () {
                return (one, index) => {};
            },
        },
        type: {
            type: String,
            required: false,
            default: '',
        },
        list: {
            type: Array,
            required: false,
            default () {
                return [];
            },
        },
    },
    data () {
        return {};
    },
    computed: {},
    mounted () {},
    methods: {
        remove (index) {
            if (this.list[index].status !== 'uploading') {
                this.list.splice(index, 1);
                this.$emit('onRemove', index);
            } else {
                // this.list.splice(index, 1);
                // this.$emit('onAbort', index);
                if (typeof this.list[index].options.cancel === 'function') {
                    console.log('取消上传' + this.list[index].rawFile.name);
                    this.list[index].options.cancel('cancel');
                } else {
                    console.log('无法取消上传' + this.list[index].rawFile.name);
                }
            }
        },
        icon (type, name) {
            // console.log(type, name);
            var extName = name.substring(name.lastIndexOf('.') + 1);
            let classstr = '';
            if (~extName.indexOf('ppt')) {
                classstr = 'icon_ppt';
            } else if (~extName.indexOf('xls')) {
                classstr = 'icon_excel';
            } else if (~extName.indexOf('doc')) {
                classstr = 'icon_doc';
            } else if (~type.indexOf('image')) {
                classstr = 'icon_pic';
            } else if (~type.indexOf('video')) {
                classstr = 'icon_video';
            } else if (~type.indexOf('audio')) {
                classstr = 'icon_audio';
            } else if (~extName.indexOf('ggb')) {
                classstr = 'icon_ggb';
            } else if (~type.indexOf('pdf')) {
                classstr = 'icon_pdf';
            } else {
                classstr = 'icon_default';
            }
            // console.log('icon ' + classstr);
            return 'icon ' + classstr;
        },
        showProgress (one) {
            if (
                one.status === 'uploading' ||
        one.status === 'process' ||
        one.status === 'succ'
            ) {
                return (isNaN(one.progress) ? 0 : one.progress) + '%';
            } else if (one.status === 'ready' || one.status === 'getMd5') {
                return one.tips || '正在等待...';
            } else if (one.status === 'fail') {
                return '上传失败';
            } else if (one.status === 'cancel') {
                return '已取消';
            }
        },
        retry (one, index) {
            one.status = 'ready';
            one.errMsg = '';
            one.progress = 0;
            if (this.type === 'uploadResume' || this.type === 'uploadAliResume') {
                console.log('uploadResume retry');
                this.retryUpload(one, index);
            } else {
                uploadQuene();
            }
        },
    },
};
</script>

    <style
      lang="scss"
      scoped
    >
.list-wrapper {
  min-width: 400px;
}
.list-wrapper * {
  box-sizing: border-box;
}
.yxp-uploader-list {
  list-style: none;
  padding: 0;
  min-width: 180px;
  li {
    font-size: 14px;
    cursor: pointer;
    list-style: none;
    padding: 14px 0px 14px 24px;
    text-align: left;
    background: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #eee;
    &:last-child {
      border-bottom: none;
    }
    &:hover {
      background: #f8f8f8;
    }
    & > .name-box {
      flex: 2 1 60%;
      & > .name {
        text-overflow: ellipsis;
        overflow: hidden;
        width: 180px;
        display: inline-block;
        white-space: nowrap;
        vertical-align: middle;
      }

      & > .icon {
        width: 20px;
        height: 24px;
        margin-right: 5px;
        display: inline-block;
        vertical-align: middle;
      }
    }

    .close-box {
      flex-grow: 0.1;
      text-align: center;
      width: 40px;
    }

    .icon-succ {
      position: relative;
      vertical-align: middle;
      width: 14px;
      height: 14px;
      display: inline-block;

      &:before {
        left: 3px;
        width: 14px;
        height: 14px;
        -webkit-border-radius: 14px;
        -moz-border-radius: 14px;
        border-radius: 14px;
        background: #2fd095;
        position: absolute;
        content: " ";
      }
      &:after {
        left: 8px;
        width: 3px;
        height: 8px;
        border-width: 0 2px 2px 0;
        border-style: solid;
        border-color: #fff;
        -webkit-transform: rotate(45deg);
        transform: rotate(45deg);
        position: absolute;
        content: " ";
        margin-top: 2px;
      }
    }

    .icon-fail {
      position: relative;
      vertical-align: middle;
      width: 14px;
      height: 14px;
      margin: 2px;
      padding: 1px;
      display: inline-block;
      background: #ff0000;
      border-radius: 50%;

      &:before {
        content: "";
        position: absolute;
        top: 50%;
        left: 0;
        z-index: 10;
        left: 6px;
        width: 2px;
        height: 10px;
        margin-top: -5px;
        background: #fff;
        -webkit-transform: rotate(45deg);
        -moz-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        -o-transform: rotate(45deg);
        transform: rotate(45deg);
      }
      &:after {
        content: "";
        position: absolute;
        top: 50%;
        left: 2px;
        width: 10px;
        height: 2px;
        margin-top: -1px;
        background: #fff;
        -webkit-transform: rotate(45deg);
        -moz-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        -o-transform: rotate(45deg);
        transform: rotate(45deg);
      }
    }

    .icon-close {
      vertical-align: middle;
      position: relative;
      width: 15px;
      height: 15px;
      padding: 3px;
      display: inline-block;
      &:before,
      &:after {
        position: absolute;
        top: 0px;
        left: 10px;
        content: " ";
        height: 12px;
        width: 1px;
        background-color: #999;
      }
      &:before {
        transform: rotate(45deg);
      }
      &:after {
        transform: rotate(-45deg);
      }
      &:hover:before {
        background-color: #333;
      }
      &:hover:after {
        background-color: #333;
      }
    }

    .icon-retry {
      border: 1px solid;
      width: 12px;
      height: 12px;
      -webkit-border-radius: 50%;
      -moz-border-radius: 50%;
      -o-border-radius: 50%;
      border-radius: 50%;
      border-right-color: transparent;
      border-left-color: transparent;
      display: inline-block;
      vertical-align: middle;
      position: relative;
      font-style: normal;
      color: #999;
      text-align: left;
      text-indent: -9999px;
      direction: ltr;
      &:before,
      &:after {
        content: "";
        position: absolute;
        width: 0;
        height: 0;
        border-width: 4px;
        border-style: solid;
        border-right-color: transparent;
        border-bottom-color: transparent;
        border-left-color: transparent;
      }
      &:before {
        -webkit-transform: rotate(-45deg);
        -moz-transform: rotate(-45deg);
        -ms-transform: rotate(-45deg);
        -o-transform: rotate(-45deg);
        transform: rotate(-45deg);
        right: -5px;
        top: 0;
      }
      &:after {
        -webkit-transform: rotate(135deg);
        -moz-transform: rotate(135deg);
        -ms-transform: rotate(135deg);
        -o-transform: rotate(135deg);
        transform: rotate(135deg);
        left: -5px;
        bottom: 0;
      }
    }
    .icon-retry:hover {
      color: #333;
    }
  }

  .progress {
    flex: 0 0 30%;
    text-align: left;
    .trough {
      width: calc(100% - 55px);
      background: #eaeef5;
      height: 4px;
      border-radius: 5px;
      display: inline-block;
      text-align: left;
      margin-right: 4px;
      vertical-align: middle;
      &.empty {
        background-color: #fff;
      }
      div {
        background: #2ed095;
        width: 0;
        display: inline-block;
        height: 4px;
        vertical-align: top;
        border-radius: 5px;
        &.fail {
          background: #ff0000;
          width: 100%;
        }
        &.fail.empty {
          color: #ff0000;
          width: 100%;
          background: #fff;
          position: relative;
          top: -10px;
        }
      }
    }
    .num {
      width: 50px;
      vertical-align: middle;
      color: #666;
      display: inline-block;
      text-align: left;
    }
  }
}
</style>

<style lang='scss' scoped src="./icons/icon.scss"></style>
